import { usePPPLocale } from '../../usePPPLocale';
import { useFormBuilder } from '@gov-nx/core/service';
import type { FormStep1Fields, FormStep1FormData } from './formSteps.types';
import {
	useContactDetailsDefinition,
	useCountryCodes,
	usePersonCommunicationForm,
} from '@gov-nx/core/hooks';

interface UseFormStep1Props {
	isDisabled: boolean;
	email?: string;
	phone?: string;
}

export const useFormStep1 = ({
	isDisabled,
	email,
	phone,
}: UseFormStep1Props) => {
	const { t } = usePPPLocale();
	const contactDetails = useContactDetailsDefinition({
		isDisabled,
		strings: {
			_useEmail: { label: t('zapis.form.step1.kontaktniUdaje.useEmail.label') },
			_usePhone: { label: t('zapis.form.step1.kontaktniUdaje.usePhone.label') },
			email: {
				label: t('zapis.form.step1.kontaktniUdaje.email.label'),
				placeholder: t('zapis.form.step1.kontaktniUdaje.email.placeholder'),
			},
			phone: {
				label: t('zapis.form.step1.kontaktniUdaje.phone.label'),
				placeholder: t('zapis.form.step1.kontaktniUdaje.phone.placeholder'),
			},
		},
	});

	const formDefinition = useFormBuilder<FormStep1FormData, FormStep1Fields>(
		contactDetails
	);

	usePersonCommunicationForm(formDefinition, {
		countryCodes: useCountryCodes(),
		email,
		phone,
	});

	return formDefinition;
};
